module.exports = __webpack_public_path__ + "img/hk_room_floorplan_07.71227eb3.png";